import React, { useState, useContext } from 'react'
import Button from '../override/Button'
import PasswordAddEdit from '../passwords/PasswordAddEdit'
import FormItem from '../override/FormItem'
import { useTranslation } from 'react-i18next'
import { Select, Tooltip } from 'antd'
import { useSelector } from 'react-redux'
import VaultContext from '../../contexts/VaultContext'

export default function EventSelect({
  label,
  placeholder,
  required,
  getFieldDecorator,
  fieldName,
  initialValue,
  mode,
  onAddComplete,
  disabled
}) {
  const { isReadonly } = useContext(VaultContext)
  const [visible, setVisible] = useState(false)
  const { activePasswords } = useSelector(state =>
    isReadonly ? state.otherPasswords : state.passwords
  )
  const { t } = useTranslation()

  return (
    <div>
      <FormItem label={`${t('PASSWORDS')} (${t('SAVE_YOUR_UPLOADED_FILE_PASSWORD')})`}>
        <div style={{ display: 'flex' }}>
          <div style={{ width: 'calc(100% - 58px)' }}>
            {getFieldDecorator(fieldName, {
              initialValue,
              rules: [
                {
                  required: required,
                  message: label && `${t('ENTER')} ${label.toLowerCase()}`
                }
              ]
            })(
              <Select
                mode={mode}
                placeholder={
                  placeholder || `${t('SELECT')} ${label.toLowerCase()}`
                }
                allowClear={!mode}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toString()
                    .toLowerCase()
                    .includes(input.trim().toLowerCase())
                }
                disabled={disabled}
              >
                {activePasswords.map(item => (
                  <Select.Option key={item._id}>{item.title}</Select.Option>
                ))}
              </Select>
            )}
          </div>
          <Tooltip title={t('ADD_NEW')}>
            <Button
              size="large"
              onClick={() => setVisible(true)}
              className={`${label ? '' : 'no-label'}`}
              style={{ marginLeft: 8 }}
              icon="plus"
              disabled={disabled}
            />
          </Tooltip>
        </div>
      </FormItem>
      <PasswordAddEdit
        visible={visible}
        setVisible={setVisible}
        onAddComplete={onAddComplete}
      />
    </div>
  )
}
